import { render, staticRenderFns } from "./ContentClassicalAdd.vue?vue&type=template&id=64ff04b8"
import script from "./ContentClassicalAdd.vue?vue&type=script&lang=js"
export * from "./ContentClassicalAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports